import { OlgaEnvironmentsAPI } from "../../providers/OlgaEnvironmentsAPI";
import { AccessStorage } from "../../storage/AccessStorage";
import Storage from "../../storage/Storage";

export class Environment {
  static async install() {
    const envInformations = await OlgaEnvironmentsAPI.me();
    const envInfos = envInformations.getData({});
    Storage.set("olga.environment.info", envInfos);
  }

  static async installConfigurations() {
    const envConfigurations = await OlgaEnvironmentsAPI.getConfigurations();
    const configurations = envConfigurations.getData({});
    Storage.set("olga.environment.configurations", configurations);
  }

  static uninstall() {
    Storage.set("olga.environment.info", null);
    Storage.set("olga.environment.configurations", null);
  }

  /**
   * @returns {String} token
   */
  static get token() {
    return AccessStorage.getAccessToken();
  }
  static get olgaToken() {
    return AccessStorage.getOcdpAccessToken();
  }

  /**
   * @returns {Object}
   */
  static get access() {
    const accessToken = Environment.token;
    const splited = accessToken?.split(".");
    if (splited && splited.length > 0) {
      return atob && atob(splited[1]);
    }
    return null;
  }

  static get configurations() {
    const configuration = Storage.get("olga.environment.configurations");
    return configuration || {};
  }

  static get me() {
    const me = Storage.get("olga.environment.info");
    return me;
  }

  static get id() {
    const me = Environment.me;
    if (!me?.id) {
      const access = Environment.access;
      return access?.environment_id;
    }
    return me?.id;
  }

  static get name() {
    const me = Environment.me;
    return me?.name;
  }

  static get defaultShortUrl() {
    const shortUrls = this.configurations["short-urls"];
    return shortUrls?.rawShortWallet || "https://4d5c.short.gy/nDVNA7";
  }
}
